<template>
  <div class="calendar-online">
    <div class="type-calendar h-48"><h2>会議の開催</h2></div>

    <SelectCategory v-show="currentStep === 'select-category'" v-model="localMeeting.category"/>

    <SetTitle v-show="currentStep === 'set-title'" v-model="localMeeting.title"/>

    <SelectUsers v-if="currentStep === 'add-users'"
                 v-model="localMeeting.selectedUsers"
                 :meeting="meeting ? meeting : {}"
                 @changeStep="changeStep"/>

    <ConfirmUsers v-if="currentStep === 'confirm-users'"
                  v-model="localMeeting.selectedUsers"
                  @changeStep="changeStep"/>

    <TimePicker v-if="currentStep === 'time-picker'"
                v-model="localMeeting.time"
                :meeting="meeting ? meeting : {}"
                @changeStep="changeStep"/>

    <Confirm v-if="currentStep === 'confirm'" :meeting="localMeeting ? localMeeting : {}" :localMeeting="localMeeting ? localMeeting : {}"/>

    <LastStep v-if="currentStep === 'last-step'"/>

    <Buttons :current-step="currentStep"
             :steps="steps"
             :meeting-category="localMeeting ? localMeeting.category : 0"
             @changeStep="changeStep"/>
  </div>
</template>

<script>
import _ from 'lodash'
import MeetingsApi from '@/api/meeting'
import Calendar from '@/components/Calendar'
import SelectCategory from '@/components/meetings/create/SelectCategory'
import SetTitle from '@/components/meetings/create/SetTitle'
import SelectUsers from '@/components/meetings/create/SelectUsers'
import ConfirmUsers from '@/components/meetings/create/ConfirmUsers'
import TimePicker from '@/components/meetings/create/TimePicker'
import Confirm from '@/components/meetings/create-online/Confirm'
import LastStep from '@/components/meetings/create-online/LastStep'
import Buttons from '@/components/meetings/create/Buttons'
import {apiErrorDialog} from '@/helpers'

export default {
  components: {
    Calendar,
    SelectCategory,
    SelectUsers,
    ConfirmUsers,
    TimePicker,
    Confirm,
    LastStep,
    Buttons,
    SetTitle
  },
  props: {
    meeting: {required: true, type: Object}
  },
  data () {
    return {
      localMeeting: {
        category: null
      },
      currentStep: 'select-category',
      steps: ['select-category', 'set-title', 'add-users', 'confirm-users', 'time-picker', 'confirm', 'last-step']
    }
  },
  methods: {
    showErrorMessage (msg) {
      this.$message.error(msg)
    },
    async changeStep (step, back = false) {
      if (!back) {
        if (this.currentStep === 'select-category') {
          if (!this.localMeeting.category) {
            this.showErrorMessage('カテゴリーを選んでください !')
            return false
          }
        } else if (this.currentStep === 'add-pharmacies') {
          if (!this.localMeeting.pharmacy) {
            this.showErrorMessage('薬局を選んでください !')
            return false
          }
        } else if (this.currentStep === 'time-picker') {
          if (!this.localMeeting.time.start || !this.localMeeting.time.end) {
            this.showErrorMessage('会議の日付を選んでください !')
            return false
          }
        } else if (this.currentStep === 'confirm') {
          await this.updateMeeting()
        } else if (this.currentStep === 'last-step') {
          return this.$router.push({name: 'home'})
        }
      }
      this.currentStep = step
    },
    async updateMeeting () {
      const loading = this.$loading.show()

      try {
        let meeting = {}
        meeting.title = this.localMeeting.title
        meeting.category_id = this.localMeeting.category
        meeting.user_ids = this.localMeeting.selectedUsers.map(n => n.id)
        meeting.start_at = this.localMeeting.time.start.format('Y-MM-DD HH:mm:00')
        meeting.end_at = this.localMeeting.time.end.format('Y-MM-DD HH:mm:00')
        await MeetingsApi.update(this.localMeeting.id, meeting)
          .catch((error) => {
            loading.hide()
            apiErrorDialog(this, error)
          })
      } catch (e) {
        console.log(e)
      }

      loading.hide()
    }
  },
  mounted () {
    this.localMeeting = _.cloneDeep(this.meeting)
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Meeting/Online/Update.vue